<template>
    <section>
      <ul class="products">
        <li v-for="item in soilItems" :key="item.id">
          <line-item
            :item="item"
            @addItem="addToCart"
            @removeFromCart="removeFromCart"
            :qtyInCart="qtyInCart(item)"
            :showDiscount="true"
          />
        </li>
      </ul>
    </section>
</template>

<script>
import LineItem from '../../../containers/orders/lineItem.vue';

export default {
  name: 'Soil',

  components: {
    LineItem,
  },

  data() {
    return {
      bulkItems: [],
    };
  },

  computed: {
    /**
     * List of soil products
     */
    soilItems() {
      return this.$store.state.soilItems;
    },

    storeBulkItems() {
      return this.$store.getters.bulkItemArray;
    },
  },

  methods: {
    addToCart(bulkProductItem) {
      if (bulkProductItem.quantity > 0) {
        const data = {
          itemType: 'bulkProductLineItems',
          item: bulkProductItem,
        };

        this.$store.commit('setProperties', { showFlyout: true });
        this.$store.dispatch('addLineItem', data);
      }
    },

    removeFromCart(bulkProductItem) {
      const data = {
        itemType: 'bulkProductLineItems',
        item: bulkProductItem,
      };
      this.$store.dispatch('removeLineItem', data);
    },

    qtyInCart(item) {
      const foundInCart = this.storeBulkItems.find((product) => product.id === item.id);

      if (foundInCart) {
        return parseInt(foundInCart.quantity, 10) || 0;
      }

      return 0;
    },
  },
};
</script>

<style scoped>

@media (max-width: 640px) {
  .products {
    justify-content: flex-start;
  }

  .products li {
    max-width: calc(50% - 5.24em);
  }

  .location-bar {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .products li {
    max-width: calc(100% - 5.24em);
  }

  .products {
    flex-direction: column;
  }

  .location-bar {
    flex-direction: column;
    align-items: center;
  }
}

</style>
